export const landRankingData = [
  {
    title: '【土地の売却方法】土地を失敗なく売るにはどうしたらよいのか？',
    url: 'https://iqrafudosan.com/smpf/tochi-baikyaku/',
  },
  {
    title: '土地を査定する前に知っておくべきことについてまとめた',
    url: 'https://iqrafudosan.com/smpf/tochi-satei/',
  },
  {
    title: '【家の売却】土地の測量が必要なケースと費用についてまとめた',
    url: 'https://iqrafudosan.com/smpf/sokuryou-hiyou/',
  },
  {
    title: '土地は買取すべき？知っておきたいポイントと判断基準を解説！',
    url: 'https://iqrafudosan.com/smpf/tochi-kaitori/',
  },
  {
    title: '【相続×不動産売却まとめ】相続した不動産の扱いについて基本から解説',
    url: 'https://iqrafudosan.com/smpf/2layer-souzoku-15969/',
  },
];

export const houseRankingData = [
  {
    title: '【不動産売却の期間・流れ・費用のまとめ】初めての不動産売却で知っておくべきこと',
    url: 'https://iqrafudosan.com/smpf/2layer-kikan-16060/',
  },
  {
    title: '【失敗しない不動産売却のコツのまとめ】初めての不動産売却で知っておくべきこと',
    url: 'https://iqrafudosan.com/smpf/2layer-sippai-16117/',
  },
  {
    title: '一戸建てを買取するなら！絶対に知っておきたいポイントを解説！',
    url: 'https://iqrafudosan.com/smpf/kodate-kaitori/',
  },
  {
    title: '一戸建ての売却期間はどれくらい？特徴を掴んでスムーズに進めよう',
    url: 'https://iqrafudosan.com/smpf/kodateperiod8795/',
  },
  {
    title: '【離婚×不動産売却まとめ】離婚時の不動産の扱いについて基本から解説',
    url: 'https://iqrafudosan.com/smpf/2layer-rikon-15924/',
  },
];

export const mansionRankingData = [
  {
    title: 'マンション売却でよくある後悔・失敗事例と失敗しないための対策を解説',
    url: 'https://iqrafudosan.com/smpf/baikyaku-sippai/',
  },
  {
    title: '築年数が古いマンションは安くでしか売れない？高く売る方法をチェック',
    url: 'https://iqrafudosan.com/smpf/oldmansion11170/',
  },
  {
    title: 'マンションを査定するときの注意点についてまとめた',
    url: 'https://iqrafudosan.com/smpf/mansion-satei/',
  },
  {
    title: '【借金・お金の問題×不動産売却まとめ】借金返済に伴う不動産売却について基本から解説',
    url: 'https://iqrafudosan.com/smpf/2layer-syakkin-16354/',
  },
  {
    title: 'マンションで飛び降り自殺！売却に影響する？事故物件になるの？',
    url: 'https://iqrafudosan.com/smpf/tobiori-mansion-baikyaku/',
  },
];
